import { BaseDto } from '../base.dto';
import { PosConfigurationDto } from './config_pos.dto';

export class PosConfigurationValueDto extends BaseDto {
  merchantId?: number;
  group: string;
  configurationTypeId?: number;
  configurationType?: PosConfigurationDto;
  value?: string;
}
